var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { buildArray } from './buildArray';
/**
 * Function that receivs an object and creates an array out of that object properties. The properties in the end result array are chosen based on the checks passed. For instance, if we passed in an object of `obj = {a : 1, b:2, c:3}`, and introduced checks to only include properties with the keys `a` and `b`, the end result would look like this: [{a:1}, {b:2}]
 *
 * @template T extends IndexedStore<any>
 * @param {T} values
 * @param {PropertyCondition[]} conditions
 *
 * @return {Partial<T>[]}
 */
export var conditionallyGroupObjectProperties = function (values) {
    var conditions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        conditions[_i - 1] = arguments[_i];
    }
    var collectionLength = conditions.length + 1;
    return Object.entries(values)
        .reduce(function (resultingObjects, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        var targetObjectIndex = conditions.findIndex(function (condition) { return condition(value, key); });
        if (targetObjectIndex === -1) {
            targetObjectIndex = collectionLength - 1;
        }
        var targetObject = resultingObjects[targetObjectIndex];
        targetObject[key] = value;
        return resultingObjects;
    }, buildArray(collectionLength, function () { return ({}); }));
};
//# sourceMappingURL=conditionallyGroupObjectProperties.js.map